<template>
  <div>
    <div class="px-5 px-md-8 py-6">
      <div class="d-flex align-center justify-space-between">
        <div class="font-weight-bold black--text" style="font-size: 18px">
          Trending videos
        </div>
        <div style="width: 130px" v-if="$vuetify.breakpoint.xsOnly">
          <v-select
            v-model="free_paid"
            :items="free_paid_list"
            :menu-props="{ bottom: true, offsetY: true }"
            label="Free/Paid"
            outlined
            hide-details
            class="selectBox"
            background-color="#fff"
            dense
            clearable
          ></v-select>
        </div>
      </div>

      <!-- Filters Start-->
      <div
        :style="$vuetify.breakpoint.smAndUp ? 'width: 70%;' : 'margin-top:15px'"
        class="pt-1"
      >
        <div :class="$vuetify.breakpoint.smAndUp ? 'd-flex' : ''">
          <div class="d-flex">
            <v-text-field
              v-model="search"
              label="Search"
              outlined
              class="selectBox"
              background-color="#fff"
              dense
              ref="inputField"
              prepend-inner-icon="mdi-magnify"
              clearable
            ></v-text-field>
          </div>
          <div
            v-if="!$vuetify.breakpoint.xsOnly"
            :class="$vuetify.breakpoint.smAndUp ? 'd-flex' : ''"
          >
            <v-select
              v-model="free_paid"
              :items="free_paid_list"
              :menu-props="{ bottom: true, offsetY: true }"
              label="Free/Paid"
              outlined
              class="selectBox"
              background-color="#fff"
              dense
              clearable
            ></v-select>
          </div>
        </div>
      </div>
      <!-- Filters End -->
      <v-row v-if="loading">
        <v-col cols="6" sm="4" md="3" v-for="item in 4" :key="item">
          <v-card>
            <v-skeleton-loader type="image, article" />
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mt-n4">
        <v-col
          :class="$vuetify.breakpoint.xsOnly ? 'mt-0' : 'mt-4'"
          class="pb-0"
          md="3"
          cols="12"
          sm="4"
          v-for="(item, index) of trending_videos"
          :key="index"
        >
          <VideoCard :value="item" :user_id="parseInt(item.profile.user)" />
        </v-col>
        <v-col cols="12">
          <div
            class="text-center heading-text pt-4"
            v-if="!trending_videos.length && !loading"
          >
            No videos Available
          </div>
        </v-col>
        <v-col
          cols="12"
          class="py-4"
          v-intersect="onIntersect"
          v-if="
            !intersectLoader && page_number !== total_page && total_page > 1
          "
        >
          <div class="text-center">
            <v-progress-circular
              indeterminate
              color="#2f80ed"
            ></v-progress-circular>
            Loading More...
          </div>
        </v-col>
      </v-row>
    </div>
    <upload-video></upload-video>
    <video-detail></video-detail>
  </div>
</template>
<script>
import Axios from "@/api/BaseAxios.js";
import VideoCard from "@/components/VideoCourse/VideoCard/VideoCard.vue";
import _ from "lodash";
import commonFunctions from "@/common/commonFunctions";
import emitterKey from "@/helper/emitterKey";
export default {
  components: {
    VideoCard,
    UploadVideo: () =>
      import(
        "@/components/VideoCourse/AddVideoData/UploadVideo/UploadVideo.vue"
      ),
    VideoDetail: () =>
      import(
        "@/components/VideoCourse/AddVideoData/VideoDetail/VideoModal.vue"
      ),
  },
  name: "VideoCourseList",
  data() {
    return {
      trending_videos: [],
      loading: false,
      free_paid_list: ["Free", "Paid"],
      user_id: commonFunctions.getUserId(),
      intersectLoader: false,
      free_paid: "",
      search: "",
      page_number: 1,
      total_page: 1,
      item_per_page: 20,
    };
  },
  created() {
    this.debounceGetList = _.debounce(function () {
      this.getTrendingVideos(true);
    }, 500);
    const self = this;
    this.eventBus.$on(emitterKey.UPDATE_VIDEO_PLAYLIST, () => {
      // console.log(emitterKey.UPDATE_VIDEO_PLAYLIST);
      self.getTrendingVideos(true);
    });
  },
  destroyed() {
    this.eventBus.$off(emitterKey.UPDATE_VIDEO_PLAYLIST);
  },
  mounted() {
    this.getTrendingVideos(true);
  },
  watch: {
    free_paid() {
      this.intersectLoader = false;
      (this.page_number = 1), this.getTrendingVideos(true);
    },
    search() {
      this.intersectLoader = false;
      (this.page_number = 1), this.debounceGetList();
    },
  },
  methods: {
    getTrendingVideos(value) {
      this.loading = true;
      const successHandler = (res) => {
        if (value) {
          this.trending_videos = res.data.trending_videos;
        } else {
          for (const obj of res.data.trending_videos) {
            this.trending_videos.push(obj);
          }
        }
        this.page_number = res.data.page_info.page_number;
        this.item_per_page = res.data.page_info.detail_count;
        this.total_page = res.data.page_info.total_page;
        this.loading = false;
      };
      const failureHandler = () => {
        this.loading = false;
      };
      let formData = {};
      formData["search"] = this.search;
      formData["free_paid"] = this.free_paid;
      formData["page_number"] = this.page_number;
      formData["detail_count"] = this.item_per_page;
      Axios.request_GET(
        "/video/trending-videos/",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    onIntersect(entries) {
      const self = this;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          self.page_number += 1;
          if (self.page_number <= self.total_page) {
            self.getTrendingVideos(false);
          } else {
            self.intersectLoader = true;
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";

.main-container {
  min-height: calc(100vh - 64px);
  overflow-y: hidden;
  background-color: #f6f7fa;
}
.selectBox {
  margin-right: 5px;
}
.filter_btn__class {
  border: 1px solid rgba(51, 51, 51, 0.08);
  border-radius: 8px;
}
.heading-text {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 18px;
  line-height: 25px;
  /* identical to box height */

  color: #333333;
}
</style>
